import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
  Fragment,
  useContext,
} from "react";
import {
  Alert,
  Button,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import PageHeader from "../common/PageHeader";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import {
  GetMyBalance,
  GetPropertyBalance,
  markAsPaidDebtToPayAsPropertyAdmin,
  fetchDebtsToPayAsPropertyOneAdmin,
  fetchDebtsToPayAsPropertyCuentaPendingTotalPaid,
  createAdvanceAdminPayment,
  fetchDebtsToPayPendingCategories,
  fetchPaymentQuote,
} from "../../helpers/api/finance";
import { useSelector } from "react-redux";
import { Toast } from "../UI/toast/Toast";
import Loader from "../common/Loader";
import ButtonIcon from "../common/ButtonIcon";
import { faDollarSign, faSearch, faCheck, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import SelectBankListItem from "../common/SelectBankListItem";
import { fetchCondominiumBanks } from "../../helpers/api/banks";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import { Controller, useForm, useWatch } from "react-hook-form";
import FullPagination from "../common/pagination/FullPagination";
import WizardError from "../auth/register/WizardError";
import FileUploadArea from "../common/FileUploadArea";
import SelectCuentasListItem from "../common/SelectCuentasListItem";
import PeriodSelect from "../common/PeriodSelect";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import classNames from "classnames";
import DebtCategoryFilter from "./DebtCategoryFilter";
import RateRuleNotice, { RATE_RULE_CLOSING } from "./RateRuleNotice";
import useSWRFetchPaginationProperty from "../../helpers/hooks/useSWRFetchPaginationProperty";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { CurrencyContext } from "../../context/Context";
import Datetime from "react-datetime";
import moment from "moment";
import InputWithLeftSelect from "../common/CurrencyAmountInput";
import { findAllCurrencies, findAllExchangeRates } from "../../helpers/api/currency";
import useExchangeRateForDate from "../../helpers/hooks/useExchangeRateForDate";
import CreateExhangeRateModal from "../exchange/components/CreateExchangeRateModal";
import {
  convertToUsd,
  convertFromUsd,
  formatAmountForBackend,
  formatAmountRounded,
  getCurrencyName,
  roundAmount,
} from "../../helpers/currencyConversion";
import useModuleBase from "../../helpers/hooks/useModuleBase";
import { fetchAllPages } from "../../helpers/api/pagination";
import usePendingDebtPeriods from "../../helpers/hooks/usePendingDebtPeriods";

// Tamaño de página para las deudas que se van a cobrar (no para el listado
// visible, que sí se pagina de a 5). Holgado para una propiedad en un período.
const DEBTS_PAGE_SIZE = 500;

const PropertyToPays = ({ setRedirect, setRedirectUrl }) => {
  const moduleBase = useModuleBase();

  const { properties, id } = useParams();
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { role } = useSelector((state) => state.auth.user);
  const { currency: curr, baseCurrency } = useContext(CurrencyContext);
  // `id` (condominio de esta planilla, de la URL) en vez de `selectedCondominium`
  // (el condominio activo en el selector global de la barra superior): si
  // quedaban desincronizados, el listado de bancos mostraba cuentas de OTRO
  // condominio, permitiendo elegir un bank_id que el backend no puede
  // asociar a la cuenta contable correcta de esta planilla (cae a la cuenta
  // CURRENT/ADVANCES genérica en vez de a la del banco elegido). Mismo bug
  // y mismo arreglo que en PropertyToPaysAdmin.jsx.
  const [params, setParams] = useState({
    condominiumId: id,
    search: null,
  });
  const { user } = useSelector((state) => state.auth);
  // Un propietario no debe poder fijar el valor de una tasa de cambio (podría
  // declarar una que le convenga); solo manager/root ven "Registrar tasa".
  const canRegisterRate = user?.role !== "property";
  const [search, setSearch] = useState("");
  const [selectedCuenta, setSelectedCuenta] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [collapseOne, collapseOneOpen] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [bank, setBank] = useState(null);
  const [fund, setFund] = useState([]);
  const [current, setCurrent] = useState([]);
  const [file, setFile] = useState(null);
  const [amount, setAmount] = useState(0);
  const [cash, setCash] = useState([]);
  const [selectedPeriods, setSelectedPeriods] = useState([]);
  const {
    periods: availableDebtPeriods,
    isLoading: isLoadingDebtPeriods,
    hasError: debtPeriodsError,
  } = usePendingDebtPeriods(id && properties ? id : null, properties);
  const [balance, setBalance] = useState({
    data: 0,
    loading: true,
    error: null,
  });
  const [totals, setTotals] = useState({
    approved: 0,
    pending: 0,
    total_amount: 0
  });
  const [availableCurrencies, setAvailableCurrencies] = useState([]);
  const [hasLoadedCurrencies, setHasLoadedCurrencies] = useState(false);
  const [hasInitializedCurrencyDefault, setHasInitializedCurrencyDefault] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const lastAutoAmountRef = useRef("");
  const hasManualAmountOverrideRef = useRef(false);
  // Clave del intento de pago en curso. Sobrevive a un fallo para que el
  // reintento reutilice la misma: ver el comentario en save().
  const paymentAttemptIdRef = useRef(null);

  const [paramPeriod, setParamPeriod] = useState({
    condominiumId: id,
    debtsToPay: properties,
  });

  const [paramPeriodTotal, setParamPeriodTotal] = useState({
    condominiumId: id,
    property_id: properties,
  });

  const [paramPeriodIncome, setParamPeriodIncome] = useState({
    condominiumId: id,
    debtsToPay: properties,
    income_only: 1,
  });
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [paymentQuote, setPaymentQuote] = useState(null);
  const [categoryTotals, setCategoryTotals] = useState(null);
  const rowBsById = useMemo(
    () =>
      Object.fromEntries(
        (categoryTotals?.rows || []).map((row) => [String(row.id), row.amount_bs])
      ),
    [categoryTotals]
  );

  const {
    data,
    handler: { goToPage, nextPage, perPage, previousPage },
    meta,
  } = useSWRFetchPagination(fetchDebtsToPayAsPropertyOneAdmin, paramPeriod);

  // data2 NO es el listado visible: es lo que realmente se cobra y se manda en
  // propertyDebtsToPay[]. Con el perPage por defecto del hook (5), un período
  // con más de 5 deudas se cobraba y conciliaba parcial, sin ningún aviso.
  // Por eso pide una página grande; save() igual verifica contra meta.total
  // antes de enviar, para que si algún día se queda corta falle visible.
  const { data: data2, meta: metaDebts } = useSWRFetchPaginationProperty(
    fetchDebtsToPayAsPropertyOneAdmin,
    paramPeriod,
    undefined,
    1,
    DEBTS_PAGE_SIZE
  );

  useEffect(() => {
    const availableIds = new Set(
      availableDebtPeriods.map((period) => String(period.id))
    );
    setSelectedPeriods((previous) =>
      previous.filter((periodId) => availableIds.has(String(periodId)))
    );
  }, [availableDebtPeriods]);

  // Filas de ingreso aplicadas a este período: se muestran aparte, como un
  // descuento ya pagado, no como deudas seleccionables para "Emitir pago".
  const { data: dataIncomes, meta: metaIncomes } = useSWRFetchPaginationProperty(
    fetchDebtsToPayAsPropertyOneAdmin,
    paramPeriodIncome,
    undefined,
    1,
    DEBTS_PAGE_SIZE
  );

  const incomeCreditByPeriod = useMemo(() => {
    return dataIncomes.reduce((acc, cuenta) => {
      const periodId = cuenta.period?.id;
      if (!periodId) return acc;
      acc[periodId] = (acc[periodId] || 0) + Math.abs(cuenta.amount);
      return acc;
    }, {});
  }, [dataIncomes]);

  const incomeCreditTotal = useMemo(
    () => Object.values(incomeCreditByPeriod).reduce((a, b) => a + b, 0),
    [incomeCreditByPeriod]
  );

  const {
    data: condominiumBanks,
    handler: {
      goToPage: cbGoToPage,
      nextPage: cbNextPage,
      perPage: cbPerPage,
      previousPage: cbPreviousPage,
    },
    isLoading: cbIsLoading,
    meta: cbMeta,
  } = useSWRFetchPagination(fetchCondominiumBanks, params);

  const {
    register,
    handleSubmit,
    formState: { errors, dirtyFields },
    setValue,
    control,
    clearErrors,
    unregister,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
    defaultValues: {
      montoOriginal: "",
      monedaOriginal: curr?.currency?.id ? String(curr.currency.id) : "",
      payment_date: moment().format("YYYY-MM-DD"),
    },
  });

  const watchedOriginalAmount = useWatch({
    control,
    name: "montoOriginal",
  });

  const watchedOriginalCurrency = useWatch({
    control,
    name: "monedaOriginal",
    defaultValue: "",
  });

  const watchedPaymentDate = useWatch({
    control,
    name: "payment_date",
    defaultValue: moment().format("YYYY-MM-DD"),
  });

  const currencyCatalog = useMemo(() => {
    const normalized = (availableCurrencies || []).map((item) => ({
      ...item,
      id: String(item.id),
      iso: (item?.iso || "").toUpperCase(),
      isFallbackUsd: false,
    }));

    const hasUsd = normalized.some((item) => item.iso === baseCurrency.iso);
    if (!hasUsd) {
      normalized.push({
        id: baseCurrency.iso,
        iso: baseCurrency.iso,
        name: getCurrencyName(baseCurrency.iso),
        isFallbackUsd: true,
      });
    }

    return normalized;
  }, [availableCurrencies, baseCurrency.iso]);

  const preferredDefaultCurrency = useMemo(() => {
    const bolivaresCurrency = currencyCatalog.find((item) => {
      const name = (item?.name || "").toLowerCase();
      const iso = (item?.iso || "").toLowerCase();
      const symbol = (item?.symbol || "").toLowerCase();

      return name.includes("boliva") || iso === "ves" || symbol === "bs" || iso === "bs";
    });

    const fallbackByBase = currencyCatalog.find(
      (item) => (item?.iso || "").toUpperCase() === baseCurrency.iso
    );

    return bolivaresCurrency || fallbackByBase || currencyCatalog[0] || null;
  }, [baseCurrency.iso, currencyCatalog]);

  const selectedCurrencyData = useMemo(() => {
    const currentValue = String(watchedOriginalCurrency || "");
    return (currencyCatalog || []).find(
      (item) =>
        String(item.id) === currentValue ||
        item.iso === currentValue.toUpperCase()
    );
  }, [currencyCatalog, watchedOriginalCurrency]);

  const isSelectedCurrencyUsd =
    (selectedCurrencyData?.iso || "").toUpperCase() === baseCurrency.iso;

  const parsedPaymentDate = useMemo(() => {
    if (!watchedPaymentDate) {
      return null;
    }

    const parsedDate = moment(watchedPaymentDate);
    return parsedDate.isValid() ? parsedDate : null;
  }, [watchedPaymentDate]);

  useEffect(() => {
    let isMounted = true;

    const loadCurrencies = async () => {
      if (!selectedCondominium) return;

      setHasLoadedCurrencies(false);

      try {
        const response = await fetchAllPages((page, pageSize) => findAllCurrencies(page, pageSize, {
          condominium_id: selectedCondominium,
        }));

        if (isMounted) {
          setAvailableCurrencies(response?.data || []);
        }
      } catch (error) {
        if (isMounted) {
          handleErrorMessage(error);
        }
      } finally {
        if (isMounted) {
          setHasLoadedCurrencies(true);
        }
      }
    };

    loadCurrencies();

    return () => {
      isMounted = false;
    };
  }, [selectedCondominium]);

  useEffect(() => {
    if (!hasLoadedCurrencies || hasInitializedCurrencyDefault || !preferredDefaultCurrency) {
      return;
    }

    setValue("monedaOriginal", String(preferredDefaultCurrency.id), {
      shouldDirty: false,
      shouldValidate: true,
    });

    setHasInitializedCurrencyDefault(true);
  }, [hasLoadedCurrencies, hasInitializedCurrencyDefault, preferredDefaultCurrency, setValue]);

  const activeExchangeRate = Number(curr?.value ?? 0);
  const [isRateModalOpen, setIsRateModalOpen] = useState(false);

  const {
    rateByDate,
    rateResolution,
    isRateLoading,
    appliedExchangeRate: hookExchangeRate,
    bumpRateRefreshTick,
  } = useExchangeRateForDate({
    currencyId: selectedCurrencyData?.id,
    isUsdCurrency: isSelectedCurrencyUsd || Boolean(selectedCurrencyData?.isFallbackUsd),
    date: parsedPaymentDate,
    activeExchangeRate,
    condominiumId: selectedCondominium,
  });

  const isCondominiumCurrency =
    Boolean(selectedCurrencyData?.id) &&
    String(selectedCurrencyData?.id) === String(curr?.currency?.id);
  const backendPaymentRate = Number(categoryTotals?.exchange_rate?.value || 0);
  const appliedExchangeRate =
    isCondominiumCurrency && backendPaymentRate > 0 ? backendPaymentRate : hookExchangeRate;
  // La cotización cubre todas las planillas elegidas; el desglose, una sola.
  const rateRule = paymentQuote?.rate_rule ?? categoryTotals?.rate_rule ?? null;
  // Dentro del periodo de gracia la tasa es la del cierre del mes y la pone el
  // backend: que falte la del día del pago no importa, y no se puede cambiar.
  const isRateFrozen =
    isCondominiumCurrency &&
    backendPaymentRate > 0 &&
    categoryTotals?.rate_rule?.type === RATE_RULE_CLOSING;
  const bsOf = (backendBs, base) =>
    isCondominiumCurrency && backendBs !== undefined && backendBs !== null
      ? Number(backendBs)
      : Number(base || 0) * appliedExchangeRate;

  const isSelectedDateToday =
    Boolean(parsedPaymentDate) && parsedPaymentDate.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD");

  const usdEquivalent = useMemo(() => {
    if (isSelectedCurrencyUsd) {
      return null;
    }

    const quoteMatchesInput =
      paymentQuote &&
      paymentQuote.amount_entered !== null &&
      paymentQuote.amount_entered !== undefined &&
      Number(paymentQuote.amount_entered) === Number(watchedOriginalAmount);
    if (quoteMatchesInput && paymentQuote.amount_base !== null && paymentQuote.amount_base !== undefined) {
      return Number(paymentQuote.amount_base);
    }

    const convertedAmount = convertToUsd(
      watchedOriginalAmount,
      false,
      appliedExchangeRate
    );

    return convertedAmount === "" ? null : convertedAmount;
  }, [appliedExchangeRate, isSelectedCurrencyUsd, watchedOriginalAmount, paymentQuote]);

  const helpText = useMemo(() => {
    if (isSelectedCurrencyUsd) {
      return "";
    }

    const effectiveRateDate = parsedPaymentDate?.isValid()
      ? parsedPaymentDate
      : (rateResolution?.usedDateKey ? moment(rateResolution.usedDateKey) : moment());
    const dateLabel = isRateFrozen
      ? `congelada ${moment(categoryTotals.rate_rule.closing_date).format("DD/MM/YYYY")}`
      : effectiveRateDate.format("DD/MM/YYYY");

    if (isRateLoading) {
      return "";
    }

    if (usdEquivalent === null) {
      return "";
    }

    const rateLabel = appliedExchangeRate
      ? formatAmountRounded(appliedExchangeRate, 2)
      : "N/D";

    return `Tasa ${dateLabel}: ${rateLabel} | Equivalente aproximado: ${baseCurrency.symbol}${formatAmountRounded(usdEquivalent, 2)} ${baseCurrency.iso}`;
  }, [
    appliedExchangeRate,
    isRateLoading,
    isSelectedCurrencyUsd,
    parsedPaymentDate,
    rateResolution,
    usdEquivalent,
    baseCurrency,
    isRateFrozen,
    categoryTotals,
  ]);

  const resolveRateForCurrency = async (currencyData) => {
    if (!currencyData) {
      return null;
    }

    const isUsdCurrency =
      (currencyData?.iso || "").toUpperCase() === baseCurrency.iso ||
      currencyData?.isFallbackUsd;

    if (isUsdCurrency) {
      return 1;
    }

    // La moneda del condominio se convierte con la tasa del backend, que es
    // la congelada al cierre cuando el pago cae en el periodo de gracia.
    if (String(currencyData.id) === String(curr?.currency?.id) && backendPaymentRate > 0) {
      return backendPaymentRate;
    }

    try {
      const response = await fetchAllPages((page, pageSize) => findAllExchangeRates(page, pageSize, {
        currency: currencyData.id,
      }));

      const rates = response?.data || [];
      const selectedDateKey = parsedPaymentDate?.format("YYYY-MM-DD");
      const rateForDay = selectedDateKey
        ? rates
          .filter(
            (rate) =>
              moment(rate.date || rate.created_at).format("YYYY-MM-DD") ===
              selectedDateKey
          )
          .sort(
            (a, b) =>
              moment(b.date || b.created_at).valueOf() -
              moment(a.date || a.created_at).valueOf()
          )[0]
        : null;

      if (selectedDateKey && !rateForDay) {
        return 0;
      }

      return Number(rateForDay?.value || appliedExchangeRate || Number(curr?.value ?? 0) || 0);
    } catch (error) {
      return Number(appliedExchangeRate || Number(curr?.value ?? 0) || 0);
    }
  };

  const handleCurrencyChange = async (event) => {
    const nextCurrency = event.target.value;
    const nextCurrencyData = (currencyCatalog || []).find(
      (item) => String(item.id) === String(nextCurrency)
    );
    const currentCurrencyData = selectedCurrencyData;

    if (!nextCurrencyData || !currentCurrencyData) {
      setValue("monedaOriginal", nextCurrency, {
        shouldDirty: true,
        shouldValidate: true,
      });
      return;
    }

    const currentIsUsd =
      (currentCurrencyData?.iso || "").toUpperCase() === baseCurrency.iso;
    const nextIsUsd =
      (nextCurrencyData?.iso || "").toUpperCase() === baseCurrency.iso;

    if (!currentIsUsd && !nextIsUsd) {
      setValue("monedaOriginal", nextCurrency, {
        shouldDirty: true,
        shouldValidate: true,
      });
      return;
    }

    let nextOriginalAmount = watchedOriginalAmount;

    if (currentIsUsd && !nextIsUsd) {
      const targetRate = await resolveRateForCurrency(nextCurrencyData);

      if (!targetRate || targetRate <= 0) {
        Toast.fire({
          type: "error",
          title: "No hay una tasa del dia disponible para convertir la moneda seleccionada.",
        });
        return;
      }

      nextOriginalAmount = convertFromUsd(
        watchedOriginalAmount,
        false,
        targetRate
      );
    } else if (!currentIsUsd && nextIsUsd) {
      const sourceRate =
        Number(appliedExchangeRate || 0) > 0 && !rateResolution?.isFallback
          ? Number(appliedExchangeRate)
          : await resolveRateForCurrency(currentCurrencyData);

      if (!sourceRate || sourceRate <= 0) {
        Toast.fire({
          type: "error",
          title: "No hay una tasa del dia disponible para convertir la moneda seleccionada.",
        });
        return;
      }

      nextOriginalAmount = convertToUsd(
        watchedOriginalAmount,
        false,
        sourceRate
      );
    }

    setValue("monedaOriginal", nextCurrency, {
      shouldDirty: true,
      shouldValidate: true,
    });

    setValue(
      "montoOriginal",
      nextOriginalAmount === "" ? "" : String(nextOriginalAmount),
      {
        shouldDirty: true,
        shouldValidate: true,
      }
    );
  };

  // Banco y referencia solo existen para transferencia. El formulario usa
  // shouldUnregister: false, asi que al cambiar el origen de fondos los campos
  // desaparecen de pantalla pero sus reglas siguen vivas: quien elegia
  // Transferencia y despues Caja o Efectivo se quedaba trabado con "El número
  // de referencia es obligatorio" sobre un campo que ya no puede ver.
  useEffect(() => {
    if (fund) {
      register("bank_id", { required: "Debes seleccionar un banco" });
    } else {
      unregister("bank_id");
      unregister("reference");
    }
  }, [register, unregister, fund]);

  useEffect(() => {
    if (selectedCuenta) {
      clearErrors("propertyDebtsToPay");
    }
  }, [selectedCuenta]);

  useEffect(() => {
    if (selectedBankId) {
      clearErrors("bank_id");
    }
  }, [selectedBankId]);

  // La caja que se puede gastar en esta pantalla es siempre la de la propiedad
  // que se esta cobrando. El propietario la pide con "/me"; el admin, que cobra
  // por cuenta de otro, la pide por id de propiedad — antes ni la pedia, y por
  // eso "Caja" no era una opcion para el (HO-TASK-245).
  useEffect(() => {
    let isMounted = true;
    if (user) {
      const getBalance = async () => {
        try {
          const {
            data: { balance },
          } = user.role === "property"
            ? await GetMyBalance()
            : await GetPropertyBalance(properties);
          isMounted &&
            setBalance((prev) => {
              return { ...prev, data: balance, loading: false };
            });
        } catch (error) {
          isMounted &&
            setBalance((prev) => {
              return { ...prev, error, loading: false };
            });
        }
      };
      getBalance();
    } else {
      setBalance((prev) => ({ ...prev, loading: false }));
    }
    return () => {
      isMounted = false;
    };
  }, [user, properties]);

  const groupedAccounts = selectedCuenta.reduce((acc, cuenta) => {
    // cuenta.period puede venir null (deuda sin período asociado, ej. datos
    // viejos); se agrupan aparte bajo una clave fija en vez de romper.
    const periodId = cuenta.period?.id ?? "sin-periodo";
    if (!acc[periodId]) {
      acc[periodId] = [];
    }
    acc[periodId].push(cuenta);
    return acc;
  }, {});

  // % de descuento por pronto pago vigente HOY para cada período (0 si el
  // período no tiene descuento configurado o ya venció la fecha límite).
  const discountPercentByPeriod = useMemo(() => {
    const list = (data2 && data2.length > 0) ? data2 : (data || []);
    return list.reduce((acc, cuenta) => {
      const period = cuenta.period;
      if (!period?.id || acc[period.id] !== undefined) return acc;
      const pct = Number(period.discount_percentage) || 0;
      const dueDate = period.discount_due_date;
      const paymentMoment = parsedPaymentDate || moment();
      const eligible =
        pct > 0 && !!dueDate && paymentMoment.isSameOrBefore(moment(dueDate), "day");
      acc[period.id] = eligible ? pct : 0;
      return acc;
    }, {});
  }, [data2, data, parsedPaymentDate]);

  // Monto que se ahorraría por pronto pago sobre lo actualmente seleccionado,
  // ya neto del crédito por ingresos/descuentos ya aplicados a cada período.
  const prospectiveDiscountByPeriod = useMemo(() => {
    return Object.entries(groupedAccounts).reduce((acc, [periodId, accounts]) => {
      const pct = discountPercentByPeriod[periodId] || 0;
      if (!pct) {
        acc[periodId] = 0;
        return acc;
      }
      const rawTotal = accounts.reduce((a, c) => a + c.amount, 0);
      const netBeforeDiscount = Math.max(
        rawTotal - (incomeCreditByPeriod[periodId] || 0),
        0
      );
      // Redondeado a centavos (igual que el backend en
      // PropertyPaymentController::applyEarlyPaymentDiscount): sin esto,
      // netAmount queda con fracciones de centavo que no coinciden con el
      // monto redondeado que se muestra/envía, y el chequeo de "monto máximo"
      // rechaza pagos que en pantalla se ven idénticos.
      acc[periodId] = Math.round(netBeforeDiscount * (pct / 100) * 100) / 100;
      return acc;
    }, {});
  }, [groupedAccounts, discountPercentByPeriod, incomeCreditByPeriod]);

  const prospectiveDiscountTotal = useMemo(
    () => Object.values(prospectiveDiscountByPeriod).reduce((a, b) => a + b, 0),
    [prospectiveDiscountByPeriod]
  );

  const save = async (values) => {

    const { payment_date, montoOriginal, monedaOriginal } = values;
    let quote = null;
    try {
      quote = await fetchPaymentQuote({
        ...quoteParams,
        period_ids: Object.keys(groupedAccounts).filter((key) => key !== "sin-periodo"),
        currency_id: monedaOriginal || quoteParams.currency_id,
        payment_date: payment_date || quoteParams.payment_date,
        amount: montoOriginal,
      });
    } catch (error) {
      quote = null;
    }
    const typedUsdValue =
      quote && quote.amount_base !== null && quote.amount_base !== undefined
        ? Number(quote.amount_base)
        : convertToUsd(
            montoOriginal,
            isSelectedCurrencyUsd,
            appliedExchangeRate
          );
    const normalizedUsdValue =
      !hasManualAmountOverrideRef.current && paramPeriod.period_id && typedUsdValue !== ""
        ? maxPayableAmount
        : typedUsdValue;
    // Misma fuente que la tarjeta y el input: ver maxPayableAmount mas abajo.
    const maxAllowedAmount = maxPayableAmount;

    if (!payment_date) {
      Toast.fire({
        type: "error",
        title: "La fecha del pago es obligatoria.",
      });
      return;
    }

    // Solo se cobra lo que esta en data2/dataIncomes: si el backend reporta
    // mas filas de las que trajimos, el monto y los ids estarian incompletos y
    // se cobraria de menos en silencio. Preferimos no emitir el pago.
    const debtsMissing =
      metaDebts.total !== null && data2.length < metaDebts.total;
    const incomesMissing =
      metaIncomes.total !== null && dataIncomes.length < metaIncomes.total;

    if (debtsMissing || incomesMissing) {
      Toast.fire({
        type: "error",
        title:
          "Este periodo tiene mas cuentas de las que se pudieron cargar. Recarga la pagina o selecciona menos periodos antes de emitir el pago.",
      });
      return;
    }

    if (
      !isSelectedCurrencyUsd &&
      (!appliedExchangeRate || appliedExchangeRate <= 0 || (rateResolution?.isFallback && !isRateFrozen))
    ) {
      Toast.fire({
        type: "error",
        title: "No hay una tasa del dia disponible para convertir esta moneda a USD.",
      });
      return;
    }

    if (normalizedUsdValue === "" || Number(normalizedUsdValue) <= 0) {
      Toast.fire({
        type: "error",
        title: "Ingresa un monto valido para procesar el pago.",
      });
      return;
    }

    // Cobrando por Caja el tope es el saldo del propietario. El backend lo
    // rechaza igual, pero avisando aca no se sube el comprobante ni se emite
    // una planilla que va a fallar.
    if (current === true && Number(normalizedUsdValue) > Number(balance.data) + 0.005) {
      Toast.fire({
        type: "error",
        title: "El propietario no tiene saldo suficiente en la Caja para realizar el pago.",
      });
      return;
    }

    const contextCurrencyIso = (curr?.currency?.iso || "").toUpperCase();
    const contextIsBaseCurrency = contextCurrencyIso === baseCurrency.iso;
    const convertedToContextCurrency = convertFromUsd(
      montoOriginal,
      contextIsBaseCurrency,
      Number(curr?.value ?? 0)
    );
    const amountConverted =
      quote && quote.amount_converted !== null && quote.amount_converted !== undefined
        ? Number(quote.amount_converted)
        : roundAmount(
      !isSelectedCurrencyUsd
        ? montoOriginal
        : convertedToContextCurrency === ""
          ? montoOriginal
          : convertedToContextCurrency
    );

    // Cobrando "Todo" el exceso es valido: lo que sobre despues de cubrir los
    // periodos queda como saldo a favor de la propiedad, mas abajo. Con una
    // categoria elegida se sigue rechazando.
    //
    // Tolerancia de medio centavo: evita rechazar por diferencias de punto
    // flotante (conversión de moneda, descuentos, etc.) entre el monto
    // redondeado que ve/envía el usuario y el máximo calculado internamente.
    if (
      !allowsOverpayment &&
      Number(normalizedUsdValue) > maxAllowedAmount + 0.005
    ) {
      Toast.fire({
        type: "error",
        title: "El monto ingresado supera el monto maximo permitido.",
      });
      return;
    }

    let remainingAmount = Number(normalizedUsdValue);
    // El monto en la moneda del banco tambien se reparte entre las planillas:
    // se calcula una sola vez sobre el total, y mandarlo entero a cada una
    // hacia que el backend sumara ese total a balance_bs una vez por periodo,
    // inflando el saldo en bolivares del banco.
    const totalUsdValue = Number(normalizedUsdValue);
    let remainingConverted = Number(amountConverted) || 0;
    let finalPayId;

    // Identifica este intento de pago. Si la peticion se reenvia —reintento del
    // cliente, timeout del upload del comprobante, dos pestañas— el backend
    // reconoce la clave y devuelve la planilla que ya creo, en vez de cobrar de
    // nuevo y duplicar movimientos y saldos. Se combina con el period_id porque
    // el bucle crea una planilla por periodo.
    //
    // La clave vive en un ref y NO se regenera mientras el intento no termine
    // bien. Eso es lo que hace recuperable un fallo a mitad del bucle: como
    // cada planilla se crea en su propia transaccion, si el tercer periodo
    // falla los dos primeros ya cobraron y no hay reversa. Al reintentar con la
    // misma clave, esos dos se reconocen y se saltan, y solo se procesa el que
    // falto. Se limpia recien cuando el pago se completa entero.
    if (!paymentAttemptIdRef.current) {
      paymentAttemptIdRef.current =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    }
    const attemptId = paymentAttemptIdRef.current;
    const rateToStore = isSelectedCurrencyUsd
      ? Number(quote?.rate_rule?.rate || backendPaymentRate || activeExchangeRate || appliedExchangeRate || 0)
      : appliedExchangeRate;

    if (cash === false || cash === true) {
      const { bank_id, reference, note } = values;
      setIsPending(true);
      try {
        for (const periodId in groupedAccounts) {
          const accountsForPeriod = groupedAccounts[periodId];
          const quotedPeriod =
            quote?.periods?.find((p) => String(p.period_id) === String(periodId)) || null;
          if (Array.isArray(accountsForPeriod)) {
            const formData = new FormData();

            const rawPeriodTotal = accountsForPeriod.reduce(
              (acc, cuenta) => acc + cuenta.amount,
              0
            );

            const isCategoryPeriod =
              hasCategoryTotals &&
              String(categoryTotals.period?.id) === String(periodId);

            // Cuando se cobra una categoría se factura EXACTAMENTE el numero
            // que ya se mostro en la tarjeta y que valido el tope de arriba.
            //
            // Recalcularlo acá con la formula del período era la raíz de varios
            // desvíos: el crédito por ingreso y el pronto pago son del período
            // completo, y aplicarlos enteros sobre el bruto de una sola
            // categoría facturaba de menos. La diferencia no se perdía, pero
            // terminaba como abono a favor en vez de saldar la deuda, la
            // categoría quedaba subpagada y el período no cerraba — con lo que
            // la última tanda perdía el pronto pago y pagar por partes salía
            // más caro que pagar todo junto.
            //
            // maxPayableAmount ya resuelve las dos ramas: con categoría usa el
            // neto del backend (que trae solo la porción prorrateada del
            // crédito) y aplica el pronto pago únicamente si esa categoría
            // cubre lo que resta del período.
            // Lo que ya se cobró de las deudas de ESTE período. Sin restarlo,
            // el primer período del bucle se llevaba su neto completo aunque
            // tuviera pagos previos, y el dinero no alcanzaba para el último:
            // pagando Agosto (neto 170, con 44.86 ya pagados) y Septiembre
            // (152.50) por 277.64, Agosto cobraba 170 y Septiembre quedaba
            // debiendo exactamente esos 44.86 de más.
            const paidInPeriod = accountsForPeriod.reduce(
              (acc, cuenta) => acc + Number(cuenta.total_paid || 0),
              0
            );

            // Tope de lo que se puede cobrar AHORA: ya descuenta lo pagado
            // antes, así que en una segunda tanda es solo el remanente.
            const chargeableNow = quotedPeriod
              ? Number(quotedPeriod.payable)
              : isCategoryPeriod
              ? maxPayableAmount
              : Math.max(
                  rawPeriodTotal -
                    paidInPeriod -
                    (incomeCreditByPeriod[periodId] || 0) -
                    (prospectiveDiscountByPeriod[periodId] || 0),
                  0
                );

            // total_amount es el total NETO de lo que esta planilla cubre, sin
            // restarle lo ya pagado: es el "de cuánto es la deuda", no "cuánto
            // falta". Si se cobra en dos tandas, las dos planillas declaran el
            // mismo total y se diferencian por su `amount` — que es lo que
            // permite leer "abonó 5.00 de 6.85". Guardando el remanente, la
            // segunda planilla decía total 1.85 y parecía otra deuda distinta.
            const billTotal = quotedPeriod
              ? Number(quotedPeriod.total_amount)
              : isCategoryPeriod
              ? Math.max(
                  selectedCategoryData.net - displayProspectiveDiscount,
                  0
                )
              : Math.max(
                  rawPeriodTotal -
                    (incomeCreditByPeriod[periodId] || 0) -
                    (prospectiveDiscountByPeriod[periodId] || 0),
                  0
                );

            const periodAmount = quotedPeriod
              ? Number(quotedPeriod.amount)
              : Math.min(chargeableNow, remainingAmount);
            remainingAmount -= periodAmount;

            // Porción del monto convertido que le toca a esta planilla. La
            // última (la que agota el monto) se lleva el remanente exacto, para
            // que la suma de las porciones dé el total sin perder centavos por
            // redondeo.
            const periodAmountConverted =
              quotedPeriod && quotedPeriod.amount_converted !== null && quotedPeriod.amount_converted !== undefined
                ? Number(quotedPeriod.amount_converted)
                : remainingAmount <= 0 || totalUsdValue <= 0
                ? remainingConverted
                : Math.min(
                    Math.round(
                      (Number(amountConverted) || 0) *
                        (periodAmount / totalUsdValue) *
                        100
                    ) / 100,
                    remainingConverted
                  );
            remainingConverted -= periodAmountConverted;

            formData.append("idempotency_key", `${attemptId}-${periodId}`);
            formData.append("amount", formatAmountForBackend(periodAmount));
            // Sin formatear, llega como 66.72999999999999 y el regex de
            // BillToPayRequest (max 6 decimales) lo rechaza con 422.
            formData.append("total_amount", formatAmountForBackend(billTotal));
            // "sin-periodo" es la clave de agrupacion de las deudas sin
            // periodo, no un id: mandarla hace que el backend la asigne a una
            // FK entera y reviente con 500.
            if (periodId !== "sin-periodo") {
              formData.append("period_id", periodId);
            }
            // 1 es lo que el backend lee como "sale de la caja del propietario"
            // (le descuenta ese saldo y no vuelve a acreditar la cuenta del
            // condominio). Para transferencia y efectivo se sigue mandando 0,
            // como hasta ahora: la distincion entre esas dos ya vive en si hay
            // bank_id y referencia.
            formData.append("payment_by_account", current === true ? 1 : 0);
            formData.append("payment_date", payment_date);
            if (rateToStore) formData.append("rate", rateToStore);
            formData.append("amount_converted", formatAmountForBackend(periodAmountConverted));
            formData.append("monedaOriginal", monedaOriginal);

            if (fund === true) {
              formData.append("bank_id", bank_id);
              formData.append("reference", reference);
            }
            if (file) formData.append("voucher", file);
            if (note) {
              formData.append("note", note);
            }

            accountsForPeriod.forEach((c, i) =>
              formData.append(`propertyDebtsToPay[${i}]`, c.id)
            );

            const { code, pay_id } = await markAsPaidDebtToPayAsPropertyAdmin(
              formData
            );
            if (code !== SUCCESS_RESPONSE.CREATED) {
              throw new Error("Error al procesar el pago.");
            }

            if (!finalPayId) {
              finalPayId = pay_id;
            }

            if (remainingAmount <= 0) break;
          }
        }

        if (quote) {
          remainingAmount = Number(quote.advance?.amount || 0);
          remainingConverted = Number(quote.advance?.amount_converted || 0);
        }

        // Con pago por Caja no se abona el excedente: seria devolverle a la
        // misma caja de la que acaba de salir el dinero. El monto ya viene
        // topado al saldo y a la deuda, asi que lo que quede aca es un resto de
        // redondeo por debajo del centavo.
        if (remainingAmount > 0 && current !== true) {
          const formData = new FormData();
          if (fund === true) {
            formData.append("bank_id", bank_id);
            formData.append("reference", reference);
          }
          // Misma clave del intento que las planillas, con su propio sufijo:
          // si la peticion se reenvia, el backend reconoce el abono ya creado
          // en vez de acreditar dos veces el excedente al propietario.
          formData.append("idempotency_key", `${attemptId}-abono`);
          formData.append("amount", formatAmountForBackend(remainingAmount));
          formData.append("payment_date", payment_date);
          // El abono se lleva el converted que no consumió ninguna planilla.
          formData.append("amount_converted", formatAmountForBackend(remainingConverted));
          formData.append("exchange_rate", appliedExchangeRate || 1);
          if (rateToStore) formData.append("rate", rateToStore);
          formData.append("property_id", properties);

          const response = await createAdvanceAdminPayment(
            formData,
            properties
          );
          if (response.code !== SUCCESS_RESPONSE.CREATED) {
            throw new Error("Error al procesar el abono.");
          }
        }

        // El intento se completó entero: el próximo pago necesita su propia
        // clave. Si algo hubiera fallado, la clave queda viva para que el
        // reintento no vuelva a cobrar los períodos que ya pasaron.
        paymentAttemptIdRef.current = null;

        collapseOneOpen(false);
        Toast.fire({
          type: "success",
          title: `Pago emitido exitosamente.`,
          text: `Para ver el resto de los pagos, dirígete al módulo de pagos.`,
          timer: 5000,
        });

        if (finalPayId) {
          setRedirectUrl(`/dashboard/${moduleBase}/${id}/pay/${finalPayId}`);
          setRedirect(true);
        }
      } catch (error) {
        handleErrorMessage(error);
        console.log(error);
      } finally {
        setIsPending(false);
      }
    }
  };

  const handleSelectAll = () => {
    setSelectedCuenta(data2);
  };

  const renderBanksItems = () => {
    return condominiumBanks.map((bank, i) => {
      return (
        <SelectBankListItem
          key={i}
          // `condominium_banks_id` (la cuenta de este banco EN este
          // condominio), no `bank.bank_id` (el banco genérico, ej: "BBVA"
          // como marca, compartido entre condominios) -- bill_to_pays.bank_id
          // referencia condominium_banks.id, así que mandar bank.bank_id
          // terminaba acreditando el pago a una cuenta de OTRO condominio
          // cuando coincidía numéricamente con un condominium_banks.id ajeno.
          id={bank.condominium_banks_id}
          selected={selectedBankId}
          onSelect={() => {
            setBank(bank);
            setSelectedBankId(bank.condominium_banks_id);
            setValue("bank_id", bank.condominium_banks_id);
          }}
          title={bank?.name}
          alternativeName="banco"
          createdAt={bank.created_at}
          owner_dni={bank.owner_dni}
          owner_name={bank.owner_name}
          account={bank.account_number}
        />
      );
    });
  };

  const renderCuentasItems = () => {
    return data.map((cuenta, i) => {
      return (
        <SelectCuentasListItem
          key={i}
          id={cuenta.id}
          selected={selectedCuenta.some((c) => c.id === cuenta.id)}
          title={
            cuenta?.name != null && cuenta?.finance?.name
              ? cuenta?.name
                ? cuenta?.name
                : cuenta.finance.name
              : cuenta?.reserve_fund?.name
          }
          alternativeName="banco"
          createdAt={cuenta?.id}
          owner_dni={cuenta?.id}
          owner_name={
            cuenta?.name != null && cuenta?.finance?.name
              ? cuenta?.name
                ? cuenta?.name
                : cuenta.finance.name
              : cuenta?.reserve_fund?.name
          }
          account={cuenta?.amount}
          rate={appliedExchangeRate}
          convertedValue={rowBsById[String(cuenta?.id)]}
          currencyIso={curr?.currency?.iso}
          categoryLabel={getCategoryLabel(cuenta?.category)}
          isPending={cuenta?.is_pending}
        />
      );
    });
  };

  useEffect(() => {
    const value = selectedCuenta.reduce((a, c) => {
      return a + c.amount;
    }, 0);
    setAmount(value);
    handleSelectAll();
  }, [selectedCuenta, data2]);

  const fetchApiTotalPaid = useCallback(async () => {
    if (!paramPeriodTotal.period_id) return;
    try {
      const response = await fetchDebtsToPayAsPropertyCuentaPendingTotalPaid(
        paramPeriodTotal
      );
      if (response && typeof response.total_amount === "number") {
        setTotals(response);
      } else {
        console.error("Response is not valid:", response);
        setTotals({ approved: 0, pending: 0, total_amount: 0 });
      }
    } catch (error) {
      console.error(error);
      setTotals({ approved: 0, pending: 0, total_amount: 0 });
    }
  }, [paramPeriodTotal]);

  useEffect(() => {
    fetchApiTotalPaid();
  }, [paramPeriodTotal]);

  const paymentDateKey =
    parsedPaymentDate && parsedPaymentDate.isValid()
      ? parsedPaymentDate.format("YYYY-MM-DD")
      : null;
  const fetchCategoryTotals = useCallback(async () => {
    if (!paramPeriod.period_id || !id) return;
    try {
      const response = await fetchDebtsToPayPendingCategories({
        condominiumId: id,
        property_id: properties,
        period_id: Array.isArray(paramPeriod.period_id)
          ? paramPeriod.period_id[0]
          : paramPeriod.period_id,
        payment_date: paymentDateKey || undefined,
      });
      // Siempre se asigna, tambien cuando viene vacio: con un if el estado
      // se quedaba con los totales del periodo anterior, y al pasar de varios
      // periodos a uno los chips no volvian a aparecer.
      setCategoryTotals(response || null);
    } catch (error) {
      console.error("Error fetching category totals:", error);
      setCategoryTotals(null);
    }
  }, [paramPeriod.period_id, id, properties, paymentDateKey]);

  useEffect(() => {
    fetchCategoryTotals();
  }, [fetchCategoryTotals]);

  const quotePeriodIds = useMemo(() => {
    const ids = Array.isArray(paramPeriod.period_id)
      ? paramPeriod.period_id
      : paramPeriod.period_id
      ? [paramPeriod.period_id]
      : [];
    return ids.filter((periodId) => periodId && periodId !== "sin-periodo");
  }, [paramPeriod.period_id]);
  const quoteCurrencyId = selectedCurrencyData?.id ?? null;
  const quoteParams = useMemo(
    () => ({
      condominium_id: id,
      property_id: properties,
      period_ids: quotePeriodIds,
      category: selectedCategory !== "all" ? selectedCategory : undefined,
      payment_date: paymentDateKey || undefined,
      currency_id: quoteCurrencyId || undefined,
    }),
    [id, properties, quotePeriodIds, selectedCategory, paymentDateKey, quoteCurrencyId]
  );

  useEffect(() => {
    if (!id || !properties || quotePeriodIds.length === 0) {
      setPaymentQuote(null);
      return undefined;
    }
    let isMounted = true;
    const handle = setTimeout(() => {
      fetchPaymentQuote({
        ...quoteParams,
        amount:
          watchedOriginalAmount !== undefined &&
          watchedOriginalAmount !== null &&
          watchedOriginalAmount !== ""
            ? watchedOriginalAmount
            : undefined,
      })
        .then((quote) => {
          if (isMounted) setPaymentQuote(quote || null);
        })
        .catch(() => {
          if (isMounted) setPaymentQuote(null);
        });
    }, 350);
    return () => {
      isMounted = false;
      clearTimeout(handle);
    };
  }, [id, properties, quotePeriodIds, quoteParams, watchedOriginalAmount]);


  const handleClick = (e) => {
    if (selectedPeriods.length > 0) {
      // El chip vuelve a "Todo", asi que el filtro del servidor tambien: sin
      // limpiar category el listado seguia filtrado por la categoria del
      // periodo anterior mientras los chips decian "Todo".
      setParamPeriod((prev) => ({
        ...prev,
        period_id: selectedPeriods,
        category: undefined,
      }));
      updateState(setParamPeriodTotal, selectedPeriods);
      updateState(setParamPeriodIncome, selectedPeriods);
      hasManualAmountOverrideRef.current = false;
      setSelectedCategory("all");
      goToPage(1);
    } else {
      console.error("No se han seleccionado períodos");
    }
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setParamPeriod((prev) => ({
      ...prev,
      category: category === "all" ? undefined : category,
    }));
    // El listado filtrado casi siempre tiene menos páginas: quedarse en la
    // página en la que estabas mostraba una lista vacía.
    goToPage(1);
  };

  const updateState = (setStateFunction, newPeriodId) => {
    setStateFunction((prev) => ({
      ...prev,
      period_id: newPeriodId,
    }));
  };

  // Mapeo de labels para categorías
  const getCategoryLabel = (category) => {
    if (!category) return "Comunes";
    if (category === "reserve_fund") return "Fondos de Reserva";
    if (category === "particular") return "Gastos Particulares";
    if (category === "initial_debt") return "Deuda Inicial";
    return "Comunes";
  };

  // Los gastos pendientes menos el descuento ya aplicado por ingresos/pronto
  // pago a planilla de este período, menos el pronto pago prospectivo (si hoy
  // todavía está dentro de la fecha límite del período). Nunca baja de 0: si
  // el ingreso supera la deuda, el excedente simplemente no se cobra (no se
  // arrastra ni se convierte en abono).
  const netAmount = Math.max(
    amount - incomeCreditTotal - prospectiveDiscountTotal,
    0
  );

  // Montos por categoría desde el backend
  const selectedCategoryData = useMemo(() => {
    if (!categoryTotals || selectedCategory === "all") {
      return null;
    }
    return categoryTotals.categories?.find(
      (c) => c.category === selectedCategory
    ) || null;
  }, [categoryTotals, selectedCategory]);

  // Al terminar de cobrar una categoría su chip queda deshabilitado: si es la
  // que estaba elegida, la pantalla se quedaba mostrando un filtro inutilizable
  // con monto 0. Se vuelve a "Todo" para que se vea lo que falta del período.
  useEffect(() => {
    if (selectedCategory === "all" || !selectedCategoryData) return;

    if (selectedCategoryData.pending <= 0.005 && selectedCategoryData.paid > 0) {
      handleCategoryChange("all");
    }
  }, [selectedCategoryData, selectedCategory]);

  // Hay totales por categoría utilizables. Una sola condición para que
  // displayNetAmount y maxPayableAmount no puedan elegir ramas distintas.
  const hasCategoryTotals = Boolean(
    selectedCategoryData && categoryTotals?.period
  );

  // Monto neto a mostrar: del backend si hay categoría específica, si no del período completo
  const displayNetAmount = useMemo(() => {
    if (hasCategoryTotals) {
      return Math.max(selectedCategoryData.net - selectedCategoryData.paid, 0);
    }
    return netAmount;
  }, [hasCategoryTotals, selectedCategoryData, netAmount]);

  // Porcentaje de pronto pago vigente para el período que se está cobrando.
  //
  // Sale del endpoint de categorías y no de discountPercentByPeriod, que toma
  // el % de un período arbitrario cuando hay varios seleccionados.
  //
  // already_discounted es lo que evita descontar dos veces: si el período ya
  // tiene su fila is_discount, el backend NO vuelve a aplicarlo
  // (EarlyPaymentDiscountTrait) y exige el neto completo. Si la UI igual
  // descontaba, cobraba de menos y la deuda no saldaba nunca.
  const activeDiscountPercent = useMemo(() => {
    const period = categoryTotals?.period;
    if (!period || period.already_discounted) {
      return 0;
    }

    const pct = Number(period.discount_percentage) || 0;
    if (!pct) return 0;

    // El backend solo aplica el descuento si la fecha del pago cae dentro de
    // la ventana; pasada esa fecha exige el neto completo. Sin este chequeo la
    // UI descontaba sobre un pronto pago vencido y cobraba de menos.
    const dueDate = period.discount_due_date;
    if (!dueDate) return 0;

    const paymentMoment = parsedPaymentDate || moment();

    return paymentMoment.isSameOrBefore(moment(dueDate), "day") ? pct : 0;
  }, [categoryTotals?.period, parsedPaymentDate]);

  // Descuento pronto pago: aplicado si la categoría cubre el resto, oportunidad si no
  const displayProspectiveDiscount = useMemo(() => {
    // Sin totales del backend no hay con que calcularlo: se usa el estimado
    // del cliente.
    if (!categoryTotals?.period) {
      return prospectiveDiscountTotal;
    }

    if (categoryTotals.period.discount_now !== undefined) {
      return selectedCategoryData
        ? Number(selectedCategoryData.discount_now || 0)
        : Number(categoryTotals.period.discount_now || 0);
    }

    const pct = activeDiscountPercent;

    if (!pct) return 0;

    // Cobrando todo el período, el descuento es el del período completo. Tiene
    // que salir de la misma cuenta que maxPayableAmount: mostrar acá el
    // estimado del cliente hacía que el desglose no cuadrara con el total
    // (el neto bajaba pero la línea del descuento no aparecía).
    if (!selectedCategoryData) {
      return (
        Math.round(categoryTotals.period.net * (pct / 100) * 100) / 100
      );
    }

    // ¿Cubre esta categoría el resto del período?
    const remainingInPeriod = categoryTotals.period.pending;
    const thisGrossPending = selectedCategoryData.pending;

    if (thisGrossPending >= remainingInPeriod - 0.01) {
      // Sí cubre → aplicar el descuento
      return Math.round(categoryTotals.period.net * (pct / 100) * 100) / 100;
    }

    return 0;
  }, [selectedCategoryData, categoryTotals, activeDiscountPercent, prospectiveDiscountTotal]);

  const [value, setValues] = useState(0);

  // Deuda del período que ya tiene un pago reportado esperando aprobación. No
  // se puede volver a cobrar sin arriesgar un doble cobro.
  const pendingApprovalTotal = useMemo(() => {
    if (!categoryTotals?.categories) return 0;
    return categoryTotals.categories.reduce(
      (acc, c) => acc + (c.pending_approval || 0),
      0
    );
  }, [categoryTotals]);

  // Los totales del backend son de UN período (fetchCategoryTotals pide
  // period_id[0]). Con varios períodos seleccionados no sirven para el total.
  // Se mira lo APLICADO (paramPeriod) y no selectedPeriods, que es lo que hay
  // en el selector: con ese, los chips aparecian y desaparecian al tocar el
  // selector, antes de apretar "Seleccionar", mostrando totales de un periodo
  // que todavia no se habia cargado.
  const hasPeriodTotals = Boolean(
    categoryTotals?.period &&
      (!Array.isArray(paramPeriod.period_id) ||
        paramPeriod.period_id.length <= 1)
  );

  // Monto a cobrar, en USD. Unica fuente de verdad: lo que se muestra en la
  // tarjeta, lo que se prellena en el input y lo que valida save().
  const maxPayableAmount = useMemo(() => {
    if (!paramPeriod.period_id) {
      return 0;
    }

    // Con categoría: cat.net ya viene neto del crédito prorrateado y cat.paid
    // es lo pagado DE ESA categoría. No se resta totals.total_amount, que es
    // del período completo: contaría dos veces lo pagado y dejaría en 0 la
    // segunda categoría que se quiera cobrar.
    if (hasCategoryTotals) {
      if (selectedCategoryData.payable !== undefined && selectedCategoryData.payable !== null) {
        return Number(selectedCategoryData.payable);
      }
      return Math.max(
        displayNetAmount -
          displayProspectiveDiscount -
          (selectedCategoryData.pending_approval || 0),
        0
      );
    }

    // "Todo" sobre un solo período: se toma del endpoint de categorías, que
    // suma TODAS las filas del período. Derivarlo del listado visible daba de
    // menos, porque ese listado solo trae las deudas con paymented = 0: al
    // cobrar una categoría sus deudas desaparecían del bruto, pero su plata
    // seguía contándose dentro de totals.total_amount, restándose dos veces.
    if (hasPeriodTotals) {
      const period = categoryTotals.period;
      if (period.payable !== undefined && period.payable !== null) {
        return Number(period.payable);
      }

      // Se resta displayProspectiveDiscount y no el porcentaje directo: es la
      // misma cifra que muestra el desglose, asi el total no puede diferir de
      // la suma de sus lineas.
      return Math.max(
        period.net -
          displayProspectiveDiscount -
          period.paid -
          pendingApprovalTotal,
        0
      );
    }

    // Varios períodos: no hay totales del backend para todos, se calcula con
    // lo que trae el listado.
    return Math.max(displayNetAmount - (totals.total_amount || 0), 0);
  }, [
    paramPeriod.period_id,
    hasCategoryTotals,
    selectedCategoryData,
    displayNetAmount,
    displayProspectiveDiscount,
    hasPeriodTotals,
    categoryTotals,
    activeDiscountPercent,
    pendingApprovalTotal,
    totals.total_amount,
  ]);

  const displayMaxPayableAmount = useMemo(() => {
    if (isSelectedCurrencyUsd) {
      return maxPayableAmount;
    }

    const backendBs = hasCategoryTotals
      ? selectedCategoryData?.payable_bs
      : hasPeriodTotals
      ? categoryTotals?.period?.payable_bs
      : undefined;
    if (isCondominiumCurrency && backendBs !== undefined && backendBs !== null) {
      return Number(backendBs);
    }
    return convertFromUsd(maxPayableAmount, false, appliedExchangeRate);
  }, [appliedExchangeRate, isSelectedCurrencyUsd, maxPayableAmount]);

  // Se admite pagar de mas siempre que NO se este cobrando una categoria
  // puntual: el excedente queda como saldo a favor de la propiedad
  // (createAdvanceAdminPayment mas abajo). Con una categoria elegida no,
  // porque el abono es del periodo completo y no de una categoria — el
  // excedente quedaria sin poder decir contra que se aplico.
  //
  // Se mira hasCategoryTotals y no selectedCategory === "all" porque con
  // varios periodos los chips no se muestran: ahi no hay categoria en juego y
  // el excedente tiene que funcionar igual, sin depender de un estado que el
  // usuario no ve.
  // Cobrar de mas contra la Caja no tiene sentido: el excedente se registra como
  // abono, que volveria a acreditar la misma caja de la que se acaba de sacar.
  const allowsOverpayment = !hasCategoryTotals && current !== true;

  // Monto que quedaria como saldo a favor. Se muestra antes de emitir, para
  // que cobrar de mas sea una decision y no una sorpresa.
  const overpaymentAmount = useMemo(() => {
    if (!allowsOverpayment || !paramPeriod.period_id) return 0;

    return Math.max(
      Math.round((Number(value) - maxPayableAmount) * 100) / 100,
      0
    );
  }, [allowsOverpayment, paramPeriod.period_id, value, maxPayableAmount]);

  // El monto tipeado supera lo que se puede cobrar. save() ya lo rechaza, pero
  // recien al apretar "Emitir pago": se avisa mientras se escribe y se
  // deshabilita el boton, para no dejar armar todo el pago y frenarlo al final.
  // Misma tolerancia de medio centavo que usa save().
  const exceedsMaxPayable =
    !allowsOverpayment &&
    paramPeriod.period_id &&
    Number(value) > maxPayableAmount + 0.005;

  // Pagando por Caja el tope real es el saldo del propietario, no la deuda.
  // Se compara contra `value` (el monto en USD que se va a cobrar) y no contra
  // `amount`, que es la suma bruta de las deudas marcadas: con un pago parcial
  // esa suma es mayor que lo que se cobra y avisaba de saldo insuficiente
  // aunque alcanzara de sobra. Misma tolerancia de medio centavo que el resto.
  const exceedsAccountBalance =
    current === true &&
    !balance.loading &&
    Number(value) > Number(balance.data) + 0.005;

  // Credito por ingreso que aplica a lo que se esta cobrando ahora: la porcion
  // prorrateada de la categoria elegida, o el credito completo del periodo si
  // se cobra todo. Mostrar siempre el total confunde: al filtrar por categoria
  // el pie decia $10 cuando a esa categoria solo le tocaban $8.19.
  //
  // Con totales del backend se usa su income_credit y no incomeCreditTotal:
  // dataIncomes pide income_only=1, que trae tanto las filas de ingreso como
  // la del pronto pago ya aplicado (is_discount), así que sumarlas contaba el
  // descuento como si fuera un ingreso más.
  const creditAppliedHere = hasCategoryTotals
    ? selectedCategoryData.credit_share
    : hasPeriodTotals
    ? categoryTotals.period.income_credit
    : incomeCreditTotal;

  const displayGross = hasPeriodTotals
    ? Number(categoryTotals.period.gross || 0)
    : Number(roundAmount(amount) || 0);
  const displayCredit = hasPeriodTotals
    ? Number(categoryTotals.period.income_credit || 0)
    : Number(roundAmount(incomeCreditTotal) || 0);

  useEffect(() => {
    const convertedValue = convertToUsd(
      watchedOriginalAmount,
      isSelectedCurrencyUsd,
      appliedExchangeRate
    );

    setValues(convertedValue === "" ? 0 : Number(convertedValue));
  }, [appliedExchangeRate, isSelectedCurrencyUsd, watchedOriginalAmount]);

  // `value` se compara siempre en USD (lo alimenta convertToUsd arriba), asi
  // que aqui va maxPayableAmount y no su version convertida.
  useEffect(() => {
    if (!watchedOriginalAmount) {
      setValues(paramPeriod.period_id ? maxPayableAmount : 0);
    }
  }, [maxPayableAmount, paramPeriod.period_id, watchedOriginalAmount]);

  useEffect(() => {
    const amountToUse = roundAmount(displayMaxPayableAmount);
    const normalizedAmount =
      amountToUse === null || amountToUse === undefined
        ? "0"
        : String(amountToUse);

    const currentAmount = String(watchedOriginalAmount ?? "");
    const lastAutoAmount = String(lastAutoAmountRef.current ?? "");

    if (!hasManualAmountOverrideRef.current || Number(currentAmount) === Number(lastAutoAmount)) {
      setValue("montoOriginal", normalizedAmount, {
        shouldDirty: false,
        shouldValidate: true,
      });
      lastAutoAmountRef.current = normalizedAmount;
      hasManualAmountOverrideRef.current = false;
    }
  }, [
    dirtyFields,
    displayMaxPayableAmount,
    setValue,
    watchedOriginalAmount,
  ]);

  return (
    <Fragment>
      <PageHeader
        title="Cuentas por pagar"
        titleTag="h2"
        className="mb-3"
        col={{ lg: 9 }}
      />
      {totals.pending > 0 && (
        <Alert color="warning" className="mb-3">
          Tienes pagos por un total de <strong>
            <NumberFormat
              value={totals.pending}
              displayType="text"
              thousandSeparator
              prefix={`${baseCurrency.symbol} `}
              decimalScale={2}
              fixedDecimalScale
            />
          </strong> pendientes de aprobación por el administrador.
        </Alert>
      )}
      <Row form>
        <Col className="pr-lg-2 mb-3" lg={8}>
          <CardBody className="bg-light">
            <Row>
              <Col tag={FormGroup}>
                <Row className="mb-2">
                  <Col xs={12}>
                    <FormGroup className="mb-0">
                      <Label for="acronym">Selecciona un período</Label>
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1 mr-2" style={{ minWidth: 0 }}>
                          <PeriodSelect
                            isMulti
                            condominiumId={id}
                            value={selectedPeriods}
                            onChange={(ids) => setSelectedPeriods(ids)}
                            availablePeriods={availableDebtPeriods}
                            isLoading={isLoadingDebtPeriods}
                            placeholder={
                              isLoadingDebtPeriods
                                ? "Cargando períodos con deuda..."
                                : "Seleccione una opción"
                            }
                            error={!selectedPeriods.length && !!errors.payment_by_account?.message}
                          />
                        </div>
                        <ButtonIcon
                          onClick={handleClick}
                          className="text-nowrap flex-shrink-0"
                          disabled={false}
                          icon={faCheck}
                          color="primary"
                        >
                          Seleccionar
                        </ButtonIcon>
                      </div>
                    </FormGroup>
                  </Col>
                  {debtPeriodsError && (
                    <Col xs={12}>
                      <Alert color="danger" className="mb-0">
                        No se pudieron cargar los períodos con deuda.
                      </Alert>
                    </Col>
                  )}
                  <Col xs={12}>
                    {!paramPeriod.period_id &&
                      errors.payment_by_account?.message && (
                        <span
                          className={classNames(
                            "text-danger d-inline-block fs--1 font-weight-normal d-block"
                          )}
                        >
                          Debes seleccionar al menos una cuenta
                        </span>
                      )}
                  </Col>
                </Row>

                {paramPeriod.period_id && (
                  <Row>
                    <Col>
                      {/* Los chips solo con un período: los totales por
                          categoría (y el prorrateo del crédito) se piden para
                          un único period_id, así que con varios seleccionados
                          los montos serían de uno solo y el cobro saldría mal.
                          Ojo: esto oculta SOLO los chips — el listado de
                          cuentas va afuera de esta condición. */}
                      {hasPeriodTotals && (
                        <DebtCategoryFilter
                          categories={(categoryTotals?.categories || []).map((c) => ({
                            category: c.category,
                            label: getCategoryLabel(c.category),
                            pending: c.pending,
                            paid: c.paid,
                          }))}
                          value={selectedCategory}
                          onChange={handleCategoryChange}
                          currency={baseCurrency.iso}
                        />
                      )}
                      {data.length >= 1 ? (
                        renderCuentasItems()
                      ) : (
                        <p>No se han encontrado cuentas por pagar.</p>
                      )}
                      <FullPagination
                        nextPage={nextPage}
                        prevPage={previousPage}
                        goToPage={goToPage}
                        meta={meta}
                        className={"shadow-none"}
                        posText={"Cuentas"}
                        perPage={perPage}
                      />
                      {dataIncomes && dataIncomes.length > 0 && (
                        <div className="mt-3 mb-3">
                          <h6 className="text-700 font-weight-bold fs--1 mb-2">
                            Ingresos aplicados a esta planilla (descuentos)
                          </h6>
                          <div className="table-responsive">
                            <table className="table table-sm table-bordered bg-white mb-0">
                              <thead className="bg-200">
                                <tr>
                                  <th>Descripción</th>
                                  <th className="text-right">Descuento</th>
                                </tr>
                              </thead>
                              <tbody>
                                {dataIncomes.map((inc) => (
                                  <tr key={inc.id}>
                                    <td>{inc.name || inc.description || "Ingreso a planilla"}</td>
                                    <td className="text-right text-success font-weight-bold">
                                      - {baseCurrency.symbol} {Number(inc.amount || 0).toFixed(2)}
                                    </td>
                                  </tr>
                                ))}
                                <tr className="bg-light font-weight-bold">
                                  <td>Total ingresos descontados</td>
                                  <td className="text-right text-success">
                                    - {baseCurrency.symbol} {Number(incomeCreditTotal).toFixed(2)}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                      <div className="card bg-white border mt-3 mb-3 p-3 shadow-none">
                        {selectedCategoryData && categoryTotals ? (
                          <>
                            <div className="d-flex justify-content-between align-items-center mb-1 fs--1">
                              <span className="text-700">Subtotal ({getCategoryLabel(selectedCategoryData.category)}):</span>
                              <span className="font-weight-semi-bold">
                                {baseCurrency.symbol} {Number(selectedCategoryData.gross).toFixed(2)} {baseCurrency.iso}
                                {appliedExchangeRate > 0 && ` | Bs ${bsOf(selectedCategoryData.gross_bs, selectedCategoryData.gross).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                              </span>
                            </div>
                            {selectedCategoryData.credit_share > 0 && (
                              <div className="d-flex justify-content-between align-items-center mb-1 fs--1 text-success font-weight-bold">
                                <span>Crédito por ingreso (prorrateado):</span>
                                <span>
                                  - {baseCurrency.symbol} {Number(selectedCategoryData.credit_share).toFixed(2)} {baseCurrency.iso}
                                  {appliedExchangeRate > 0 && ` | - Bs ${bsOf(selectedCategoryData.credit_share_bs, selectedCategoryData.credit_share).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                </span>
                              </div>
                            )}
                            {displayProspectiveDiscount > 0 && (
                              <div className="d-flex justify-content-between align-items-center mb-1 fs--1 text-success font-weight-bold">
                                <span>Descuento pronto pago (aplicado):</span>
                                <span>
                                  - {baseCurrency.symbol} {Number(displayProspectiveDiscount).toFixed(2)} {baseCurrency.iso}
                                  {appliedExchangeRate > 0 && ` | - Bs ${bsOf(hasCategoryTotals ? selectedCategoryData?.discount_now_bs : categoryTotals?.period?.discount_now_bs, displayProspectiveDiscount).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                </span>
                              </div>
                            )}
                            {displayProspectiveDiscount === 0 && categoryTotals.period && activeDiscountPercent > 0 && (
                              <div className="d-flex justify-content-between align-items-center mb-1 fs--1 text-warning">
                                <span>Descuento pronto pago (oportunidad):</span>
                                <span>
                                  si pagas el resto (
                                  {baseCurrency.symbol} {Number(Math.max(categoryTotals.period.pending - selectedCategoryData.pending, 0)).toFixed(2)}
                                  ) antes del{" "}
                                  {categoryTotals.period.discount_due_date
                                    ? new Date(categoryTotals.period.discount_due_date).toLocaleDateString("es-VE")
                                    : "N/D"}{" "}
                                  ahorrás{" "}
                                  {baseCurrency.symbol}{" "}
                                  {Number(
                                    Math.round(
                                      categoryTotals.period.net *
                                        (activeDiscountPercent / 100) *
                                        100
                                    ) / 100
                                  ).toFixed(2)}
                                </span>
                              </div>
                            )}
                            <hr className="my-2" />
                            <div className="d-flex justify-content-between align-items-center font-weight-bold">
                              <span>Total neto a pagar:</span>
                              <span className="text-primary fs-0">
                                {baseCurrency.symbol}{" "}
                                {Number(maxPayableAmount).toFixed(2)}{" "}
                                {baseCurrency.iso}
                                {appliedExchangeRate > 0 &&
                                  ` | Bs ${bsOf(selectedCategoryData?.payable_bs, maxPayableAmount).toLocaleString("es-VE", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}`}
                              </span>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="d-flex justify-content-between align-items-center mb-1 fs--1">
                              <span className="text-700">Subtotal de cuentas:</span>
                              <span className="font-weight-semi-bold">
                                {baseCurrency.symbol} {Number(displayGross).toFixed(2)} {baseCurrency.iso}
                                {appliedExchangeRate > 0 && ` | Bs ${bsOf(categoryTotals?.period?.gross_bs, displayGross).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                              </span>
                            </div>
                            {displayCredit > 0 && (
                              <div className="d-flex justify-content-between align-items-center mb-1 fs--1 text-success font-weight-bold">
                                <span>Descuento ingresos aplicados:</span>
                                <span>
                                  - {baseCurrency.symbol} {Number(displayCredit).toFixed(2)} {baseCurrency.iso}
                                  {appliedExchangeRate > 0 && ` | - Bs ${bsOf(categoryTotals?.period?.income_credit_bs, displayCredit).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                </span>
                              </div>
                            )}
                            {displayProspectiveDiscount > 0 && (
                              <div className="d-flex justify-content-between align-items-center mb-1 fs--1 text-success font-weight-bold">
                                <span>Descuento pronto pago:</span>
                                <span>
                                  - {baseCurrency.symbol} {Number(displayProspectiveDiscount).toFixed(2)} {baseCurrency.iso}
                                  {appliedExchangeRate > 0 && ` | - Bs ${bsOf(hasCategoryTotals ? selectedCategoryData?.discount_now_bs : categoryTotals?.period?.discount_now_bs, displayProspectiveDiscount).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                </span>
                              </div>
                            )}
                            <hr className="my-2" />
                            <div className="d-flex justify-content-between align-items-center font-weight-bold">
                              <span>Total neto a pagar:</span>
                              <span className="text-primary fs-0">
                                {baseCurrency.symbol} {Number(maxPayableAmount).toFixed(2)} {baseCurrency.iso}
                                {appliedExchangeRate > 0 && ` | Bs ${bsOf(categoryTotals?.period?.payable_bs, maxPayableAmount).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                      {selectedCuenta.length === 0 && (
                        <span
                          className={classNames(
                            "text-danger d-inline-block fs--1 font-weight-normal d-block mt-2"
                          )}
                        >
                          Debes seleccionar al menos una cuenta
                        </span>
                      )}
                      <WizardError
                        error={errors.propertyDebtsToPay?.message}
                        className="fs--1 font-weight-normal d-block"
                      />
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>

            <Row>
              <Col sm tag={FormGroup}>
                <Label for="acronym">Origen de fondos</Label>
                <Controller
                  name="payment_by_account"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "Seleccione un fondo",
                    },
                    validate: () => {
                      if (exceedsAccountBalance) {
                        return "";
                      }
                      return true;
                    },
                  }}
                  render={({ onChange, name, value }) => (
                    <Input
                      type="select"
                      name="payment_by_account"
                      id="payment_by_account"
                      value={value || "Selecciona"}
                      className={`${errors.payment_by_account?.message
                        ? "border-danger"
                        : ""
                        } form-select, overflow-auto`}
                      onChange={(event) => {
                        setFund(event.target.value === "2");
                        setCurrent(event.target.value === "1");
                        setCash(event.target.value === "3");
                        setValue("payment_by_account", event.target.value);
                        onChange(`${event.target.value}`);
                      }}
                    /*    onChange={handleInputChange}
                               innerRef={register({
                                 required: { value: true, message: "Ingresar el monto" },
                               })} */
                    >
                      <option value="Selecciona" disabled>
                        ---
                      </option>
                      {/* "del propietario" es a proposito: esta pantalla la usa
                          el administrador cobrandole a otro, y "Caja" a secas no
                          dejaba ver de que caja sale la plata. */}
                      <option value="1">Caja del propietario</option>
                      <option value="2">Transferencia</option>
                      <option value="3">Efectivo</option>
                    </Input>
                  )}
                />
                <WizardError
                  error={errors.payment_by_account?.message}
                  className="fs--1 font-weight-normal d-block"
                />
                {current === true && !balance.loading && (
                  <span className="fs--1 text-700 d-block mt-1">
                    Saldo disponible en la caja del propietario:{" "}
                    <NumberFormat
                      className="text-nowrap"
                      value={balance.data}
                      thousandSeparator
                      decimalScale={2}
                      fixedDecimalScale
                      prefix={`${baseCurrency.symbol} `}
                      displayType="text"
                    />
                  </span>
                )}
              </Col>
            </Row>

            {exceedsAccountBalance && (
              <Row className="p-card">
                <Col>
                  <Alert color="danger" className="mb-0">
                    El propietario no tiene saldo suficiente en la Caja para
                    realizar el pago, puedes registrarle un abono ahora mismo
                    pulsando el siguiente enlace
                    <Button
                      data-testid="Button"
                      tag={Link}
                      color="link"
                      size="sm"
                      className="ml-1 pl-0"
                      to={`/dashboard/${moduleBase}/${id}/advance/add`}
                    >
                      Abonar saldo
                    </Button>
                  </Alert>
                </Col>
              </Row>
            )}
            {fund === true && (
              <Row>
                <Col tag={FormGroup}>
                  <Label>Seleccione un banco del condominio</Label>
                  <Row>
                    <Col tag={FormGroup} xs={9} className="pr-0">
                      <Input
                        type="text"
                        placeholder="Ingrese el nombre de un banco"
                        onChange={(event) => setSearch(event.target.value)}
                      />
                    </Col>
                    <Col tag={FormGroup} xs={3}>
                      <ButtonIcon
                        className="btn-block"
                        style={{ whiteSpace: "nowrap" }}
                        icon={faSearch}
                        color="falcon-default"
                        onClick={() =>
                          setParams((prev) => {
                            return { ...prev, search };
                          })
                        }
                      >
                        Buscar
                      </ButtonIcon>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      {!cbIsLoading ? (
                        condominiumBanks.length >= 1 ? (
                          renderBanksItems()
                        ) : (
                          <p>No se han encontrado bancos.</p>
                        )
                      ) : (
                        <Loader padding="py-3" />
                      )}
                      <FullPagination
                        nextPage={cbNextPage}
                        prevPage={cbPreviousPage}
                        goToPage={cbGoToPage}
                        meta={cbMeta}
                        className={"shadow-none"}
                        posText={"bancos"}
                        perPage={cbPerPage}
                      />
                      {!selectedBankId && (
                        <span
                          className={classNames(
                            "text-danger d-inline-block fs--1 font-weight-normal d-block"
                          )}
                        >
                          Debes seleccionar un banco
                        </span>
                      )}
                      <WizardError
                        error={errors.bank_id?.message}
                        className="fs--1 font-weight-normal d-block"
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
            {fund === true && (
              <FormGroup>
                <Label for="name">Nombre del banco</Label>
                <Input
                  disabled
                  defaultValue={bank?.name || undefined}
                  autoComplete="off"
                  name="name"
                  id="title"
                  placeholder="Nombre del banco"
                />
              </FormGroup>
            )}
            {fund === true && (
              <Row form>
                <Col sm tag={FormGroup}>
                  <Label for="account_number">Número de cuenta</Label>
                  <NumberFormat
                    disabled
                    value={bank?.account_number || undefined}
                    format="#### #### #### #### #### #### ####"
                    placeholder="Número de cuenta"
                    className="form-control"
                    renderText={(value, props) => <div {...props}>{value}</div>}
                  />
                </Col>
                <Col sm tag={FormGroup}>
                  <Label for="owner_name">Nombre del propietario</Label>
                  <Input
                    disabled
                    defaultValue={bank?.owner_name || undefined}
                    autoComplete="off"
                    name="owner_name"
                    id="owner_name"
                    placeholder="Nombre del propietario"
                  />
                </Col>
              </Row>
            )}
            {fund === true && (
              <Row form>
                <Col sm tag={FormGroup}>
                  <Label for="owner_dni">Identificación (DNI)</Label>
                  <Input
                    defaultValue={bank?.owner_dni || undefined}
                    id="owner_dni"
                    name="owner_dni"
                    disabled
                    type="text"
                    placeholder="Identificación"
                  />
                </Col>
              </Row>
            )}
            {fund === true && (
              <Row>
                <Col tag={FormGroup}>
                  <FileUploadArea
                    label="Comprobante de pago"
                    accept="image/*,application/pdf"
                    onChange={(e) => {
                      const f = e.target.files[0];
                      if (f) {
                        setFile(f);
                        setImagePreview(URL.createObjectURL(f));
                      }
                    }}
                    preview={imagePreview}
                    fileName={file?.name}
                    onRemove={() => {
                      setFile(null);
                      setImagePreview(null);
                    }}
                    error={errors?.voucher?.message}
                  />
                </Col>
              </Row>
            )}
            {cash === true && (
              <Row>
                <Col tag={FormGroup}>
                  <FileUploadArea
                    label="Comprobante de pago"
                    accept="image/*,application/pdf"
                    onChange={(e) => {
                      const f = e.target.files[0];
                      if (f) {
                        setFile(f);
                        setImagePreview(URL.createObjectURL(f));
                      }
                    }}
                    preview={imagePreview}
                    fileName={file?.name}
                    onRemove={() => {
                      setFile(null);
                      setImagePreview(null);
                    }}
                    error={errors?.voucher?.message}
                  />
                </Col>
              </Row>
            )}

            {fund === true && (
              <Row>
                <Col tag={FormGroup}>
                  <Label>Código de referencia</Label>

                  <Input
                    className={classNames({
                      "border-danger": errors?.reference?.message,
                    })}
                    type="text"
                    name="reference"
                    id="reference"
                    /*          onChange={({ e }) => {
                          setValue("reference", e.target.value);
                          onChange(`${e.target.value}`);
                        }} */

                    innerRef={register({
                      required: "El número de referencia es obligatorio.",
                      minLength: {
                        value: 5,
                        message:
                          "El número de referencia debe tener al menos 5 caracteres.",
                      },
                    })}
                  /*    onChange={(e) => setValue("reference", e.target.value)
                  onChange(`${e.target.value}`)
                } */
                  />
                  <WizardError
                    error={errors?.reference?.message}
                    className="fs--1 font-weight-normal d-block"
                  />
                </Col>
              </Row>
            )}

            <Row>
              <Col tag={FormGroup}>
                <Label for="note">Nota</Label>
                <Input
                  type="textarea"
                  name="note"
                  id="note"
                  placeholder="Escribe una nota adicional..."
                  innerRef={register({
                    maxLength: {
                      value: 200,
                      message: "La nota no puede exceder los 200 caracteres.",
                    },
                  })}
                  onChange={(e) => {
                    if (e.target.value.length > 200) {
                      e.target.value = e.target.value.slice(0, 200);
                    }
                  }}
                />
                <WizardError
                  error={errors.note?.message}
                  className="fs--1 font-weight-normal d-block"
                />
              </Col>
            </Row>
          </CardBody>
        </Col>
        <Col className="pl-lg-2 mb-3" lg={4}>
          <CardBody className="bg-light">
            <FormGroup>
              <Label for="payment_date">
                Fecha del pago <span className="text-danger">*</span>
              </Label>
              <Controller
                name="payment_date"
                control={control}
                rules={{ required: "La fecha del pago es obligatoria." }}
                render={({ onChange, value }) => (
                  <Datetime
                    value={value ? moment(value) : ""}
                    className={`w-100 ${errors.payment_date?.message ? "border-danger" : ""}`}
                    onChange={(date) => {
                      const parsedDate = moment(date);
                      onChange(
                        parsedDate.isValid()
                          ? parsedDate.format("YYYY-MM-DD")
                          : ""
                      );
                    }}
                    dateFormat="DD/MM/YYYY"
                    timeFormat={false}
                  />
                )}
              />
              <WizardError
                error={errors.payment_date?.message}
                className="fs--1 font-weight-normal d-block"
              />
            </FormGroup>

            <FormGroup className="mb-3">
              <Label className="mb-1">Monto total a pagar:</Label>
              <p className="mb-0 fs--1 font-weight-semi-bold text-800">
                {isRateLoading ? (
                  <small className="text-muted font-weight-normal">
                    <FontAwesomeIcon icon={faSpinner} spin className="mr-1" />
                    Consultando tasa...
                  </small>
                ) : (
                  <>
                    <NumberFormat
                      displayType="text"
                      thousandSeparator
                      decimalScale={2}
                      fixedDecimalScale
                      value={displayMaxPayableAmount}
                      prefix={
                        selectedCurrencyData?.iso
                          ? `${selectedCurrencyData.iso} `
                          : `${baseCurrency.symbol} `
                      }
                    />
                    {!isSelectedCurrencyUsd && (
                      <span className="text-muted font-weight-normal ml-2 fs--1">
                        ({baseCurrency.symbol} {Number(maxPayableAmount).toFixed(2)} {baseCurrency.iso})
                      </span>
                    )}
                  </>
                )}
              </p>
            </FormGroup>

            <Row className="align-items-center py-2">
              <Col>
                <Controller
                  name="montoOriginal"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "Ingresar el monto",
                    },
                  }}
                  render={({ onChange, value: formValue }) => (
                    <>
                      <InputWithLeftSelect
                        stacked
                        selectLabel="Moneda a pagar"
                        selectValue={watchedOriginalCurrency || ""}
                        onSelectChange={handleCurrencyChange}
                        selectOptions={(currencyCatalog || []).map((item) => ({
                          value: String(item.id),
                          label: `${item.iso} (${item.name})`,
                        }))}
                        errorMessage={errors.montoOriginal?.message}
                        helpText={helpText}
                        selectAriaLabel="Moneda original"
                      >
                        <Label className="mb-1 font-weight-semi-bold">Monto a pagar</Label>
                        <NumberFormat
                          customInput={Input}
                          thousandSeparator
                          prefix={
                            selectedCurrencyData?.iso
                              ? `${selectedCurrencyData.iso} `
                              : ""
                          }
                          fixedDecimalScale
                          decimalScale={2}
                          onValueChange={(vals) => {
                            const nextValue = vals.value || "";
                            hasManualAmountOverrideRef.current =
                              Number(nextValue) !== Number(lastAutoAmountRef.current ?? 0);
                            onChange(nextValue);
                          }}
                          value={formValue || ""}
                          placeholder="0.00"
                          className={classNames("font-weight-bold shadow-sm", {
                            "border-danger": errors.montoOriginal,
                          })}
                        />
                      </InputWithLeftSelect>
                      {isRateLoading && (
                        <small className="text-muted d-block mt-1">
                          <FontAwesomeIcon icon={faSpinner} spin className="mr-1" />
                          Consultando tasa para la fecha...
                        </small>
                      )}
                      <RateRuleNotice rule={rateRule} />
                      {!isSelectedCurrencyUsd && rateResolution?.isFallback && !isRateLoading && !isRateFrozen && (
                        <Alert color="warning" className="mt-2 mb-0 py-2 fs--1">
                          No se encontró la tasa oficial registrada para la fecha{" "}
                          <strong>{moment(rateResolution.selectedDateKey).format("DD/MM/YYYY")}</strong>.
                          {canRegisterRate ? (
                            <>
                              {" "}
                              <Button
                                color="link"
                                className="p-0 fs--1 font-weight-bold text-decoration-none ml-1"
                                onClick={() => setIsRateModalOpen(true)}
                              >
                                Registrar tasa
                              </Button>
                            </>
                          ) : (
                            " Se está utilizando una tasa de referencia."
                          )}
                        </Alert>
                      )}
                    </>
                  )}
                />
              </Col>
            </Row>

            {Boolean(watchedOriginalAmount) && !isSelectedCurrencyUsd && (
              <CardBody className="border border-warning bg-soft-warning rounded mb-2 py-2 px-3">
                <span className="fs--1 text-700">
                  El monto que se guardara en el sistema sera el equivalente en {getCurrencyName(baseCurrency.iso)} {baseCurrency.symbol}. El valor mostrado es la referencia original ingresada por el usuario.
                </span>
              </CardBody>
            )}
            <Row>
              <Col>
                {exceedsMaxPayable && (
                  <span className="fs--1 text-danger mb-2 d-block font-weight-semi-bold">
                    El monto supera lo que queda por cobrar (
                    {baseCurrency.symbol}{" "}
                    {Number(maxPayableAmount).toFixed(2)} {baseCurrency.iso}).
                    Para cobrar de más, quita el filtro de categoría.
                  </span>
                )}
                {overpaymentAmount > 0 && (
                  <span className="fs--1 text-warning mb-2 d-block font-weight-semi-bold">
                    Se cubren los períodos y quedan {baseCurrency.symbol}{" "}
                    {Number(overpaymentAmount).toFixed(2)} {baseCurrency.iso} como
                    saldo a favor del propietario.
                  </span>
                )}
                {totals.approved > 0 && (
                  <span className="fs--1 text-success mb-2 d-block">
                    Monto pagado:{" "}
                    <NumberFormat
                      className="text-nowrap"
                      value={data?.length > 0 ? totals.approved : 0}
                      thousandSeparator
                      decimalScale={2}
                      fixedDecimalScale
                      prefix={`${baseCurrency.symbol} `}
                      displayType="text"
                    />
                  </span>
                )}
                {totals.pending > 0 && (
                  <span className="fs--1 text-warning mb-2 d-block">
                    Monto por aprobar:{" "}
                    <NumberFormat
                      className="text-nowrap"
                      value={data?.length > 0 ? totals.pending : 0}
                      thousandSeparator
                      decimalScale={2}
                      fixedDecimalScale
                      prefix={`${baseCurrency.symbol} `}
                      displayType="text"
                    />
                  </span>
                )}
                {paramPeriod.period_id && creditAppliedHere > 0 && (
                  <span className="fs--1 text-info mb-2 d-block">
                    Descuento aplicado (ingreso a planilla):{" "}
                    <NumberFormat
                      className="text-nowrap"
                      value={creditAppliedHere}
                      thousandSeparator
                      decimalScale={2}
                      fixedDecimalScale
                      prefix={`${baseCurrency.symbol} `}
                      displayType="text"
                    />
                  </span>
                )}
                {paramPeriod.period_id && displayProspectiveDiscount > 0 && (
                  <span className="fs--1 text-success mb-2 d-block">
                    Descuento por pronto pago aplicado al total a pagar:{" "}
                    <NumberFormat
                      className="text-nowrap"
                      value={displayProspectiveDiscount}
                      thousandSeparator
                      decimalScale={2}
                      fixedDecimalScale
                      prefix={`${baseCurrency.symbol} `}
                      displayType="text"
                    />
                  </span>
                )}
              </Col>
            </Row>
            <ButtonIcon
              color="primary"
              icon={faDollarSign}
              onClick={() => collapseOneOpen(!collapseOne)}
              className="btn-block"
              disabled={value <= 0 || isRateLoading || exceedsAccountBalance}
            >
              Emitir pago
            </ButtonIcon>
          </CardBody>
        </Col>
      </Row>
      <Modal isOpen={collapseOne} data-testid="modal">
        <ModalHeader>Confirmación</ModalHeader>
        <ModalBody>
          <p className="mb-0 font-weight-bold fs--1">
            ¿Está seguro de que ingresó todos los datos correctamente? Esta
            información no puede ser cambiada posteriormente.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button disabled={isPending} onClick={() => collapseOneOpen(!collapseOne)}>
            Cancelar
          </Button>
          <Button
            data-testid="submit-button"
            color="primary"
            type="submit"
            disabled={
              isPending ||
              isRateLoading ||
              exceedsMaxPayable ||
              exceedsAccountBalance
            }
            onClick={handleSubmit(save, (formErrors) => {
              // El modal de confirmación tapa el formulario: si react-hook-form
              // bloquea el envío por un campo obligatorio sin completar (banco,
              // referencia, etc.), antes no se veía nada — el error quedaba
              // oculto detrás del modal. Esto lo hace visible.
              const firstError = Object.values(formErrors)[0];
              Toast.fire({
                type: "error",
                title:
                  firstError?.message ||
                  "Revisa los campos obligatorios antes de continuar (banco, referencia, etc.).",
              });
            })}
          >
            {isPending && <Spinner size="sm" className="mr-2" />}
            Sí, pagar
          </Button>
        </ModalFooter>
      </Modal>
      <CreateExhangeRateModal
        isOpen={isRateModalOpen}
        setIsOpen={setIsRateModalOpen}
        currency={selectedCurrencyData || { name: "", iso: "", id: null }}
        baseCurrency={baseCurrency}
        mutate={bumpRateRefreshTick}
        condominiumId={selectedCondominium}
        suggestedValue={activeExchangeRate}
      />
    </Fragment>
  );
};

export default withRedirect(PropertyToPays);
